<div class="bp-modal mod-lg" [class.no-invite]="!hasEmailAddress()">
  <div class="bp-modal-body">
    <div class="header">
      <img
        class="payment-ref-logo mt-15"
        src="/assets/images/success_contact_header.svg"
        [alt]="'contact_header_image_alt_text' | translate" />
      <div class="mt-15 font-size-24 stronger-text">{{ "Success!" | translate }}</div>
      <div class="mt-10 mb-15 text-light">
        {{ "added_contact_to_contact_list" | translate: [getContactName()] }}
      </div>
    </div>
    @if (hasEmailAddress()) {
      <div class="flex-column-horizontal invite">
        <span class="stronger-text">{{ "invite_contact_title" | translate }}</span>
        <span class="text-light mt-15 mb-20">{{ "invite_contact_description" | translate }}</span>
        @if (!isInvited()) {
          <a
            (click)="invite()"
            (keydown.enter)="invite()"
            [tabIndex]="0"
            class="stronger-text items-center">
            <span class="bpi__icon-email stronger-text mr-10"></span>
            {{ inviteButtonText | translate }}
          </a>
        } @else {
          <span class="text-green pr-20">
            <span class="bpi__icon-check"></span>
            {{ "taf_invite_sent" | translate }}
          </span>
        }
      </div>
    }
  </div>
  <div class="modal-footer justify-center">
    <button type="button" class="btn btn-primary" (click)="closeAll()">{{ "close" | translate }}</button>
  </div>
</div>
